// extracted by mini-css-extract-plugin
export default {"row":"history_row__uDeKv","column":"history_column__kigaL","repairs-list":"history_repairs-list__nYwvJ"};